/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardTab: {
  name: 'keyboard-tab';
  data: string;
} = {
  name: 'keyboard-tab',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11.59 7.41 15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"/></svg>`
};
